import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import AfterRegistrationStep1 from "./AfterRegistrationStep1";
import AfterRegistrationStep2 from "./AfterRegistrationStep2";
import AfterRegistrationStep3 from "./AfterRegistrationStep3";
import AfterRegistrationStep4 from "./AfterRegistrationStep4";
import {
  CustomButton,
  CustomCard,
  CardTitle,
  StyledContent,
} from "./AfterSignUpStyle";

const AfterRegistration = (props: { setLoggedIn: (values: any) => void }) => {
  const { setLoggedIn } = props;

  const { t } = useTranslation("after_sign_up");
  const navigate = useNavigate();

  const [step, setStep] = useState(0);

  // Lifecyles methods
  useEffect(() => {
    message.info("Success! Your account is now activated.", 3);
  }, []);

  // Handlers
  const handleOnClick = () => {
    setStep(step + 1);
  };

  const handleOnClickPrev = () => {
    setStep(step - 1);
  };

  const handleClickBookAClass = () => {
    setLoggedIn(true);
    navigate("/my-level");
  };

  if (step === 0) {
    return (
      <StyledContent className="content-container confirm-registration-container">
        <CustomCard className="step1">
          <CardTitle className="step1">
            {t("Next Steps").toUpperCase()}
          </CardTitle>
          <AfterRegistrationStep1 />
        </CustomCard>
        <CustomButton className="to-flexi-btn" onClick={handleOnClick}>
          {t("Start").toUpperCase()}
        </CustomButton>
      </StyledContent>
    );
  }

  if (step === 1) {
    return (
      <StyledContent className="content-container confirm-registration-container">
        <CustomCard className="step2">
          <CardTitle>
            <button
              type="button"
              className="icon-btn"
              onClick={handleOnClickPrev}
            >
              <FontAwesomeIcon
                icon={faArrowLeft as IconProp}
                className="icon"
                size="2x"
              />
            </button>
            {t("Confirm Time Zone").toUpperCase()}
          </CardTitle>
          <AfterRegistrationStep2 />
        </CustomCard>
        <CustomButton className="to-flexi-btn" onClick={handleOnClick}>
          {t("Confirm Time Zone").toUpperCase()}
        </CustomButton>
      </StyledContent>
    );
  }

  if (step === 2) {
    return <AfterRegistrationStep3 setStep={setStep} />;
  }
  if (step === 3) {
    return (
      <StyledContent className="content-container confirm-registration-container">
        <CustomCard className="step4">
          <CardTitle>
            <button
              type="button"
              className="icon-btn"
              onClick={handleOnClickPrev}
            >
              <FontAwesomeIcon
                icon={faArrowLeft as IconProp}
                className="icon"
                size="2x"
              />
            </button>
            {t("Book Your Class").toUpperCase()}
          </CardTitle>
          <AfterRegistrationStep4 />
        </CustomCard>
        <CustomButton className="to-flexi-btn" onClick={handleClickBookAClass}>
          {t("Let's Start").toUpperCase()}
        </CustomButton>
      </StyledContent>
    );
  }
  return null;
};
export default AfterRegistration;
